import Repository from './Repository'
const resource = '/trains'

export default {
  /**
   * 沿線リストを取得する
   * @param {Array} prefCds 都道府県コード
   */
  async getLines(prefCds) {
    const params = { pref_cds: prefCds }
    return await Repository.get(`${resource}/lines`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 駅リストを取得する
   * @notice `沿線から探す` 用に、パラメーターは複数想定（配列）
   * @param {Array} lineCds 沿線CD
   * @param {Array} prefCds 都道府県コード
   * @param {Array} lineNames 沿線名
   */
  async getStations(lineCds, prefCds, lineNames) {
    const params = { line_cds: lineCds, pref_cds: prefCds, line_names: lineNames }
    return await Repository.get(`${resource}/stations`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
